import {
  Box,
  Button,
  FormControl,
  FormLabel,
  IconButton,
  InputAdornment,
  Stack,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import RscLogo from "../../assests/logo/rscLogo";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useDispatch } from "react-redux";
import {
  forgottonPassword,
  verifyEmailByOtp,
} from "../../reducers/authentication.slice";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/authContext";

const ForgotPasswordWrapper = styled(Stack)(({ theme }) => ({
  minHeight: "100vh", // This ensures it takes at least full viewport height
  height: "100%", // This can make sure the element fills the screen
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#000000",
  overflow: "auto", // Ensure content doesn't overflow outside the viewport
}));

const ForgotPasswordPageComponent = styled(Stack)(({ theme }) => ({
  padding: "24px",
  backgroundColor: "#101010",
  borderRadius: "10px",
  border: "1px solid #ffffff85",
  width: "370px",
  [theme.breakpoints.down("md")]: {
    width: "480px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "320px",
    padding: "16px",
  },
  [theme.breakpoints.down("xs")]: {
    width: "95%",
    padding: "16px",
  },
}));

const LogoSectionWrapper = styled(Stack)(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
}));

const LogoDisplaySection = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1.5),
  backgroundColor: "white",
  width: "fit-content",
  borderRadius: "3px",
  marginBottom: "20px",
}));

const CustomFormLabel = styled(FormLabel)(({ theme }) => ({
  color: "white",
  marginBottom: "8px",
  fontFamily: "Inter",
  letterSpacing: "0.8px",
  marginTop: "10px",
}));

const LogoSection = styled(Stack)(({ theme, image }) => ({
  width: "10%",
  height: "20px",
  padding: "5px",
  backgroundImage: `url(${image})`,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
}));

const SignUpContentSection = styled(Stack)(({ theme, image }) => ({
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
}));

const SignUpAction = styled(Stack)(({ theme, image }) => ({
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
}));

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [emailVid, setEmailVid] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const { loginType } = useContext(AuthContext);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  const { showToast } = useContext(AuthContext);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleCheckEmail = () => {
    if (!emailRegex.test(email)) {
      setError(true);
    } else {
      const payload = {
        email,
        email_type: "FORGOT_OTP",
      };
      dispatch(forgottonPassword(payload)).then((res) => {
        if (res?.error && Object.keys(res?.error)?.length > 0) {
          showToast(res?.error?.message, "error");
          return;
        }
        setEmailVid(res?.payload?.id);
        setActiveStep(1);
      });
    }
  };

  useEffect(() => {
    let interval = null;

    if (activeStep === 1 && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }

    return () => clearInterval(interval);
  }, [timer, activeStep]);

  const handleResendOtp = () => {
    // Add your re API logic here
    const payload = {
      email,
      email_type: "RESEND_OTP",
    };
    dispatch(forgottonPassword(payload)).then((res) => {
      if (res?.error && Object.keys(res?.error)?.length > 0) {
        showToast(res?.error?.message, "error");
        return;
      }
      setEmailVid(res?.payload?.id);
      setActiveStep(1);
    });
    setTimer(60);
    setCanResend(false);
  };

  const handleVerifyOtp = () => {
    if (verificationCode.length === 6) {
      const payload = {
        otp: verificationCode,
        id: emailVid,
      };
      dispatch(verifyEmailByOtp(payload)).then((res) => {
        if (res?.error && Object.keys(res?.error)?.length > 0) {
          showToast(res?.error?.message, "error");
          return;
        }
        if (loginType) {
          localStorage.setItem("access_token", res?.payload?.access_token);
        } else {
          sessionStorage.setItem("access_token", res?.payload?.access_token);
        }

        navigate("/reset-password", {
          state: { email, emailVid, access_token: res?.payload?.access_token },
        });
      });
    }
  };

  return (
    <>
      <ForgotPasswordWrapper>
        <ForgotPasswordPageComponent>
          <LogoSectionWrapper>
            <LogoDisplaySection>
              <RscLogo color="black" />
            </LogoDisplaySection>
            {activeStep === 1 && (
              <Stack
                gap={1}
                flexDirection={"row"}
                alignContent={"center"}
                color={"#ffffff85"}
                sx={{ cursor: "pointer" }}
                onClick={() => setActiveStep(0)}
              >
                <KeyboardBackspaceIcon />{" "}
                <Typography fontFamily={"inter"}>Back</Typography>
              </Stack>
            )}
          </LogoSectionWrapper>
          {activeStep === 0 ? (
            <>
              <Typography
                sx={{
                  fontSize: "1.7rem",
                  color: "white",
                  fontWeight: 700,
                }}
              >
                Forgot Password?{" "}
              </Typography>
              <Typography
                sx={{
                  color: "#ffffff85",
                  fontFamily: "Inter",
                  fontWeight: 300,
                  fontSize: "0.8rem",
                }}
              >
                No worries! Just enter your email address below, and we’ll send
                you a link to reset it.{" "}
              </Typography>
              <FormControl fullWidth sx={{ marginTop: 2 }}>
                <CustomFormLabel htmlFor="lastName">Email</CustomFormLabel>
                <TextField
                  type="email"
                  name="email"
                  value={email}
                  placeholder="Email"
                  onChange={handleInputChange}
                />
                <Button
                  disabled={email.length === 0}
                  variant="contained"
                  onClick={handleCheckEmail}
                  sx={{ marginBottom: 18 }}
                >
                  Next
                </Button>
              </FormControl>
            </>
          ) : (
            <>
              <Typography
                sx={{
                  fontSize: "1.7rem",
                  color: "white",
                  fontWeight: 700,
                }}
              >
                Verify Your Identity{" "}
              </Typography>
              <Typography
                sx={{
                  color: "#ffffff85",
                  fontFamily: "Inter",
                  fontWeight: 300,
                  fontSize: "0.8rem",
                }}
              >
                We’ve sent a verification code to your email. Please enter the
                code below to proceed with resetting your password.{" "}
              </Typography>
              <FormControl fullWidth sx={{ marginTop: 2 }}>
                <CustomFormLabel htmlFor="lastName">
                  Verification Code
                </CustomFormLabel>
                <TextField
                  type={showPassword ? "text" : "password"}
                  name="verification_password"
                  value={verificationCode}
                  sx={{ marginBottom: 1 }}
                  placeholder="Verification Code"
                  onChange={(e) => setVerificationCode(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ marginRight: 3 }}>
                        <IconButton
                          aria-label={
                            showPassword
                              ? "hide the password"
                              : "show the password"
                          }
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          onMouseUp={handleMouseUpPassword}
                          edge="end"
                        >
                          {showPassword ? (
                            <VisibilityOff sx={{ color: "#ffffff85" }} />
                          ) : (
                            <Visibility sx={{ color: "#ffffff85" }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography variant="body2" sx={{ marginTop: 2 }}>
                  {canResend ? (
                    <Stack gap={1} flexDirection={"row"}>
                      <Typography
                        onClick={canResend ? handleResendOtp : null}
                        variant="body2"
                        sx={{
                          cursor: canResend ? "pointer" : "default",
                          textTransform: "none",
                        }}
                      >
                        Didn't receive verification code? Resend code
                      </Typography>
                    </Stack>
                  ) : (
                    `Didn't receive Verification Code? Resend in ${timer}s`
                  )}
                </Typography>
                <Button
                  disabled={verificationCode.length === 0}
                  variant="contained"
                  sx={{ marginBottom: 18 }}
                  onClick={handleVerifyOtp}
                >
                  Submit
                </Button>
              </FormControl>
            </>
          )}
        </ForgotPasswordPageComponent>
      </ForgotPasswordWrapper>
    </>
  );
};

export default ForgotPasswordPage;
